import { DateTime } from 'luxon'

export const getTimeDiff = (lastSendTime: number, delay: number) => {
  const ms = DateTime.fromMillis(lastSendTime + delay * 1000).diff(DateTime.now()).toMillis()
  return Math.floor(ms / 1000)
}
